import React from "react";
import { Container, Navbar, Row, Col, CloseButton } from "react-bootstrap";
import { useHistory } from "react-router";
import "./HRM.css";
import "../DrillDownPage.css";
import { useSelector } from "react-redux";

const HRMHeader = () => {
  const history = useHistory();
  const hrmData = useSelector((state) => state?.dashboard?.hrm);
  const interval = useSelector((state) => state?.globalFilters?.interval);

  return (
    <Navbar className="header-hrm drilldown-header">
      <Container fluid className="px-0">
        <Row className="drilldown-header-row w-100 align-items-center g-2">
          <Col xs={12} sm={7} md={6} lg={5}>
            <div className="drilldown-header-brand">
              <div className="drilldown-header-brand-icon">
                <img src="/images/dashboard/hme.png" alt="Heart Rate Monitoring Events" />
              </div>
              <div className="drilldown-header-title-block">
                <span className="header-text">Heart Rate Monitoring Events</span>
              </div>
              <div className="drilldown-header-count">
                <span className="event-count">{hrmData?.counts?.total}</span>
              </div>
            </div>
          </Col>
          <Col xs={12} lg={4} className="drilldown-header-stats-col">
            <div className="drilldown-header-stats">
              <span className="drilldown-header-stat-item">
                <strong>{hrmData?.counts?.lowThresholdEvents}</strong>
                Low Threshold Events
              </span>
              <span className="drilldown-header-stat-item">
                <strong>{hrmData?.counts?.highThresholdEvents}</strong>
                High Threshold Events
              </span>
            </div>
          </Col>
          <Col xs={12} sm={5} md={6} lg={3}>
            <div className="drilldown-header-actions">
              <h5 className="event-days">{interval}</h5>
              <CloseButton
                style={{ opacity: "1" }}
                variant="white"
                aria-label="Hide"
                onClick={() => history.goBack()}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </Navbar>
  );
};

export default HRMHeader;
